import { isEmpty } from 'lodash';
export const isEmptyAnswer = (a) => isEmpty(a);
//# sourceMappingURL=types.js.map